import * as routerNames from '@/services/router/router.names'

import AccountRegistrationComplete from '@/screens/account-registration/account-registration-complete.vue'
import AccountRegistrationAddMembers from '@/screens/account-registration/account-registration-add-members.vue'
import AccountRegistrationUsher from '@/screens/account-registration/account-registration-usher.vue'

export default [
  {
    path: '/registration/account/complete',
    name: routerNames.ACCOUNT_REGISTRATION_COMPLETE,
    component: AccountRegistrationComplete,
  },
  {
    path: '/registration/account/usher',
    name: routerNames.ACCOUNT_REGISTRATION_USHER,
    component: AccountRegistrationUsher,
  },
  {
    path: '/:accountId/registration/add-members',
    name: routerNames.ACCOUNT_REGISTRATION_ADD_MEMBERS,
    component: AccountRegistrationAddMembers,
    meta: {
      adminOwnerOnly: true,
    },
  },
]
